import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6eec12af")

_pushScopeId("data-v-6eec12af")
const _hoisted_1 = { class: "interval-tag-left" }
const _hoisted_2 = { class: "interval-tag-text" }
const _hoisted_3 = { class: "interval-tag-right" }
const _hoisted_4 = { class: "interval-tag-check" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", {
    class: ["interval-tag", {'interval-tag-active':_ctx.active}]
  }, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1)
    ]),
    _createVNode("div", _hoisted_3, [
      (_ctx.imgSrc)
        ? (_openBlock(), _createBlock("img", {
            key: 0,
            class: "interval-tag-img",
            src: _ctx.imgSrc,
            alt: ""
          }, null, 8, ["src"]))
        : _createCommentVNode("", true)
    ]),
    _withDirectives(_createVNode("div", _hoisted_4, null, 512), [
      [_vShow, _ctx.active]
    ])
  ], 2))
})